import i18n from 'l10n';
import Handlebars from 'handlebars';
import moment from 'moment';
import GenericView from 'js/views/generic.view';
import SubscriberModel from 'js/models/subscriber.model';
import CampaignConfiguration from 'js/models/campaign.config.model';
import UserModel from 'js/models/userrelatedinfo.model';
import dhtmlx from 'dhtmlxAdapter';
import Template from 'js/templates/subscriber.hbs';
import SubscriberTopPartPartial from 'js/templates/partials/subscriber.page.top.part.partial.hbs';
import MessagesView from 'js/views/messages.view';
import TilesView from 'js/views/subscriber.groups.tiles.view';
import {el, handles, on, tagName, template} from "../adapters/backbone-decorators";
import {delegateEvent} from "../utils/event.delegator";
import {$} from "../adapters/backbone-ajaxq-adapter";

require('metroHelpers');
require('jsFileUpload');

@template(Template)
@el("#single-subscriber-container")
@tagName("span")
class SubscriberView extends GenericView {

    subscriberTopPartPartial = Handlebars.compile(SubscriberTopPartPartial);

    constructor(options) {
        super(options);
        Handlebars.registerPartial("cityId", Handlebars.compile("{{ name }}"));
        Handlebars.registerPartial("subscriberType", Handlebars.compile("{{ name }}"));
        Handlebars.registerPartial("gender", Handlebars.compile("{{#if this }}" +
            "{{#equals value 'MALE'}}{{t 'subscriber.genderMale'}}" +
            "{{else equals value 'FEMALE'}}{{t 'subscriber.genderFemale'}}" +
            "{{else equals value 'NONE'}}{{t 'subscriber.genderNone'}}" +
            "{{else equals value 'OTHER'}}{{t 'subscriber.genderOther'}}" +
            "{{/equals}}" +
            "{{/if}}"));

        this.loadSubscription().then(() => console.log("Subscription loaded."));
    }

    async loadSubscription() {
        try {
            let response = await $.getDefaultJSONQ(`/CampaignCloud/Subscription/${this.id}/getWithExtras`);
            let customFields = await $.getDefaultQ('/CampaignCloud/CustomFields');
            customFields.forEach((customField) => {
                if (customField.type === "multipleChoice") {
                    customField.values = customField.values.split(",");
                    response.extras.forEach((resp) => {
                        if (resp.type === "tinytext" && resp.name === customField.name) {
                            const newCustomFieldObj = $.extend({}, resp, customField);
                            response.extras[response.extras.length] = newCustomFieldObj;
                        }
                    });
                }
            });


            // response.extras.push(tempCustomField);
            // Object.assign(response.extras, tempCustomField);
            this.model = new SubscriberModel(response.subscription);
            this.model.set("extras", response.extras);
            // this.model.set("customFields", customFields);
            try {
                const data = {};
                data['subscriptionId'] = parseInt(this.id);
                const {value} = await $.ajaxDefaultQ({
                    url: "/CampaignCloud/Subscription/getLoyaltyCode",
                    data: data,
                    type: "POST",
                    dataType: 'json'
                });
                this.subscriberCode = value;
            } catch (e) {
                console.info(e);
            }

            delegateEvent(this.model, this, "toggleBlock");
            delegateEvent(this.model, this, "toggleBounced");

            await this.getAdditionalInfo();

            this.render();
            this.loadSubscriberRating(this.id);

            await this.loadGroups();
            this.loadMessages();
            await this.loadNamedayInfo();

        } catch (e) {
            console.info(e);
        }
    }

    async getAdditionalInfo() {
        const {isReferenced, blockDate, hasPhoto} = await $.getDefaultJSONQ(`${this.model.url()}/AdditionalInfo`);

        this.isReferenced = isReferenced;
        this.model.set("blockedDate", blockDate);
        this.model.set("hasPhoto", hasPhoto);

        const {bouncedEmailDate} = await $.getDefaultJSONQ(`${this.model.url()}/getEmailBouncedDate`);
        const {bouncedSmsDate} = await $.getDefaultJSONQ(`${this.model.url()}/getSmsBouncedDate`);

        this.model.set("bouncedEmailDate", bouncedEmailDate);
        this.model.set("bouncedSmsDate", bouncedSmsDate);
    }

    async loadGroups() {

        const {data} = await $.getDefaultJSONQ(`${this.model.url()}/Groups`);

        this.groupTilesView = new TilesView({
            collection: data,
            contactModel: this.model,
            groupsCount: this.$(".groups-count")
        });

        this.groupTilesView.renderCollection();

        const blocked = data.filter(obj => obj.id === 1).length > 0;
        this.toggleBlockedState(blocked);

        const bounced = data.filter(group => group.title === 'BOUNCED EMAILS').length > 0;
        this.toggleEmailState(bounced);

        const smsBounced = data.filter(group => group.title === 'BOUNCED SMS').length > 0;
        this.toggleMsisdnState(smsBounced);

    }

    toggleBlockedState(blocked) {
        this.blocked = blocked;
        this.toggleState({
            value: blocked,
            dateSelector: "#blocked-date",
            attr: "blockedDate",
            parent: ".toggle-block",
            positive: '.blocked',
            negative: '.unblocked',
            icon: ".image-badge.icon-record"
        });

    }

    toggleEmailState(emailBounced) {
        this.emailBounced = emailBounced;
        this.toggleState({
            value: emailBounced,
            dateSelector: "#bounced-email-date",
            attr: "bouncedEmailDate",
            parent: ".toggle-email-bounce",
            positive: '.email-bounced',
            negative: '.email-unbounced',
            icon: ".image-badge.fa-snowflake-o"
        });
    }

    toggleMsisdnState(smsBounced) {
        this.smsBounced = smsBounced;
        this.toggleState({
            value: smsBounced,
            dateSelector: "#bounced-sms-date",
            attr: "bouncedSmsDate",
            parent: ".toggle-sms-bounce",
            positive: '.sms-bounced',
            negative: '.sms-unbounced',
            icon: ".image-badge.icon-locked"
        });
    }

    toggleState(parameters) {
        let {value, dateSelector, attr, parent, positive, negative, icon} = parameters;
        if (!value) {
            this.$(dateSelector).html("");
            delete this[attr];
            this.model.unset(attr);
        }
        this.$(icon).toggle(value);
        this.$(parent).find(positive).toggle(value);
        this.$(parent).find(negative).toggle(!value);
    }

    loadMessages() {
        // Protective code. Because the backbone event is triggered multiple times.
        // Todo Inspection
        // Although the trigger is not called multiple times upon group fetch
        // the event in queue is dequeued multiple times.
        if (!this.messagesView) {
            this.messagesView = new MessagesView({
                collectionUrl: `${this.model.url()}/MessagesWithFilters`,
                subscription: this.model
            });
        }
    }

    hide() {
        this.$el.hide();
    }

    show() {
        this.$el.show();
    }

    render() {
        super.render();

        this.showHideSendButtons(this);

        this.$('[data-i18n]').i18n();

        const customFieldIds = this.model.get("extras").filter(x=> x.type === "multipleChoice").map(x => x.id);
        customFieldIds.forEach(id => {
            const valueOfMultipleChoice = this.model.get("extras").filter(x => x.type === "multipleChoice" && x.id === id).map(x => x.value).toString();
            $(`#checkCFValues-${id}`).val(valueOfMultipleChoice);
        });
    }

    async updateNamedayInfo() {
        try {
            const response = await $.getDefaultJSONQ(this.model.url());
            if (response) {
                this.model.get('subscriber').nameDayId = response.subscriber.nameDayId;
                this.loadNamedayInfo();
            }
        } catch (e) {
            console.log(e);
        }
    }

    async loadNamedayInfo() {
        if (this.model.get("subscriber").nameDayId) {
            try {
                const response = await $.getDefaultQ(`/CampaignCloud/Subscription/nextNameday/${this.model.get("subscriber").nameDayId}`);
                if (response) {
                    var newdt = new Date(response);
                    console.log(response);
                    var d = newdt.getDate();
                    var m = newdt.getMonth();
                    m += 1;
                    var y = newdt.getFullYear();
                    var dt = (d + "/" + m + "/" + y);
                    var t = (i18n.t("subscriber.nameday") + dt);
                    this.$('#namedayinfo').show().text(t);
                } else {
                    this.$('#namedayinfo').hide().text('');
                }

            } catch (e) {
                console.log(e);
            }
        } else {
            this.$('#namedayinfo').hide().text("");
        }
    }

    showHideSendButtons(self) {
        let hasEmail = !!self.model.get("subscriber").email;
        self.$('#send-email').toggle(hasEmail);
        self.$('.toggle-email-bounce').toggle(hasEmail);
        let hasMsisdn = !!self.model.get("msisdn");
        self.$('#send-sms').toggle(hasMsisdn);
        self.$('.toggle-sms-bounce').toggle(hasMsisdn);
    }

    updateCallback(attributeName, value, outcome, e, settings) {

        if (attributeName === "subscriber.firstName" || attributeName === "subscriber.lastName"
            || attributeName === "subscriber.email" || attributeName === "msisdn") {

            $("#subscriberTopPart").html(this.subscriberTopPartPartial(this.model.attributes));
        }
        if (attributeName === "subscriber.email" || attributeName === "msisdn") {
            this.showHideSendButtons(this);
        }
        if (attributeName === "subscriber.email") {
            this.updateSubscriberGroups();
        }

        if ("OK" === outcome) {
            var b = "true" === value.toString();
            var newHtml = b ? "true" : "";
            $(e).find('.hidden').html(newHtml);
            if (value) {
                $(e).removeClass('busy');
                $(e).addClass('available');
            } else {
                $(e).addClass('busy');
                $(e).removeClass('available');
            }

            if (attributeName === "subscriber.firstName") {
                this.updateNamedayInfo();
            }
        }
        return super.updateCallback(attributeName, value, outcome, e, settings);
    }

    deleteCallback(data) {
        if (data.outcome === "OK") {
            //model.clear();
            this.$el.remove();
            $.Notify.show(i18n.t("subscriber.deletionoutcome"));
            document.location = "#";
        } else {
            $.Notify.error(i18n.t("subscriber.cannotdelete"));
        }
    }

    @on('click #photoConf')
    stopPropagation(e) {
        e.stopPropagation();
    }

    @on('click #composeMessage')
    toggleVisibility() {
        var e = $("#sendmessagefloatingbutton");
        if (e.css("display") === 'block') {
            e.css("display", "none");
        } else {
            e.css("display", "block");
        }
    }

    @on('click #send-sms')
    sendSms(ev) {
        this.sendMessage(ev, 'SMS');
    }

    @on('click #send-email')
    sendEmail(ev) {
        this.sendMessage(ev, 'EMAIL');
    }

    sendMessage(ev, channel) {
        var self = this;

        var CCmodel = new CampaignConfiguration({campaignChannel: channel});

        var userModel = new UserModel();
        userModel.fetch({
            success: function () {
                CCmodel.set("userId", userModel.id);
                CCmodel.set("sender", channel === 'SMS' ? userModel.get("username").replace(/\./g, "").substring(0, 11) : userModel.get("username"));

                var attr = "contactIds";
                var existingContacts = CCmodel.get(attr);
                existingContacts.push(self.model.get("subscriptionId"));
                CCmodel.set(attr, existingContacts);

                CCmodel.save(CCmodel.attributes, {
                    success: function (model) {
                        location.href = "Message.htm#" + model.get("id");
                    }
                });
            }
        });

        return false;
    }

    @on('click .toggle-block')
    toggleBlock() {
        if (this.blocked) {
            this.model.unblockContact(1);
        } else {
            this.model.blockContact(1);
        }
    }

    @on('click .toggle-email-bounce')
    toggleEmailBounced() {
        const self = this;
        $.ajaxDefaultQ({
            url: '/CampaignCloud/Group/bouncedEmailGroupGId',
            type: 'get',
            dataType: 'json'
        }).done(function (response) {
            if (response) {
                if (self.emailBounced) {
                    self.model.unblockContact(response);
                } else {
                    self.model.blockContact(response);
                }
            }
        }).fail(function (response) {
            console.log(response);
        });
    }

    @on('click .toggle-sms-bounce')
    toggleSmsBounced() {
        const self = this;
        $.ajaxDefaultQ({
            url: '/CampaignCloud/Group/bouncedSmsGroupGId',
            type: 'get',
            dataType: 'json'
        }).done(function (response) {
            if (response) {
                if (self.smsBounced) {
                    self.model.unblockContact(response);
                } else {
                    self.model.blockContact(response);
                }
            }
        }).fail(function (response) {
            console.log(response);
        });
    }

    numberTypeIsValid(e, input, c) {
        var spriteel = $(input).parent().parent().parent().find("#countryFlag");
        spriteel.html('');
        spriteel.addClass("flag-icon");
        spriteel.addClass("flag-icon-" + c.toLowerCase());
        $('.icon-warning').remove();
        var $msisdn = $('#msisdn-error-message');
        $msisdn.empty();
        $msisdn.hide();
        $(input).parent().parent().parent().find('#country-code').text(` ${c} `);
        $(input).removeClass("invalid").addClass("valid");
        // TODO: Check this if working
        this.$el.find("button[type=submit]").removeAttr("disabled");
    }

    numberTypeIsInvalid(e, input) {
        var msisdn = input[0].value;
        var spriteel;
        var $msisdn = $('#msisdn-error-message');
        if (msisdn) {
            spriteel = $(input).parent().parent().parent().find("#countryFlag");
            spriteel.removeClass();
            spriteel.html('<i class="icon-warning fg-darkRed"></i>');
            $(input).parent().parent().parent().find('#country-code').text('');
            $msisdn.show();
            $msisdn.text(i18n.t("subscriber.invalidnumbertype"));
            $(input).removeClass("valid").addClass("invalid");
            //TODO: check if this works
            this.$el.find("button[type=submit]").attr("disabled", "disabled");
        } else if (this.model.get("subscriber").email && this.model.get("subscriber").email) {
            spriteel = $('#countryFlag');
            spriteel.html("");
            $('.icon-warning').remove();
            $msisdn.empty();
            $msisdn.hide();
            $(input).parent().parent().parent().find('#country-code').text('');
            $(input).removeClass("invalid").addClass("valid");
            $(input).parent().parent().parent().find("#countryFlag").removeClass();
            this.$el.find("button[type=submit]").removeAttr("disabled");
        } else {
            spriteel = $(input).parent().parent().parent().find("#countryFlag");
            spriteel.removeClass();
            spriteel.html('<i class="icon-warning fg-darkRed"></i>');
            $(input).parent().parent().parent().find('#country-code').text('');
            $msisdn.show();
            $msisdn.text(i18n.t("subscriber.invalidnumbertype"));
            this.$el.find("button[type=submit]").attr("disabled", "disabled");
            $(input).removeClass("valid").addClass("invalid");
        }
    }

    numberSubmit(input) {
        var val = input[0].value;
        if (!val) {
            $(input).parent().parent().parent().find("#countryFlag").removeClass();
            $(input).parent().parent().parent().find('#country-code').text('');
        }
        if (!input.hasClass('valid')) {
            $(input).parent().parent().parent().find('#country-code').text('');
            $(input).parent().parent().parent().find("#countryFlag").removeClass();
            return false;
        }

    }

    numberBlur(e, c, input) {
        var message = $(e).next("span");
        message.empty();
        message.hide();
        if ($(e).hasClass('msisdn')) {
            var spriteel = $('#countryFlag');
            spriteel.removeClass();
            spriteel.addClass("flag-icon");
            var $country = $('#country-code');
            $country.text('');
            $('.icon-warning').remove();
            if (c) {
                spriteel.addClass(`flag-icon-${c.toLowerCase()}`);
                $country.text(` ${c} `);
            } else {
                $(input).parent().parent().parent().find("#countryFlag").removeClass();
            }

            $(input).removeClass("invalid").addClass("valid");
        }
        var val = input[0].value;
        if (!val || !$(input).hasClass("valid")) {
            $(input).parent().parent().parent().find("#countryFlag").removeClass();
            $(input).parent().parent().parent().find('#country-code').text('');
        }
    }

    inputIsValid(e, input) {
        var message = $(e).next("span");
        message.empty();
        message.hide();
        $(input).removeClass("invalid").addClass("valid");
    }

    inputIsInvalid(e, input, maxLength) {
        var message = $(e).next("span");
        message.text(i18n.t("profile.invalidlengthinput", {countLength: maxLength}));
        message.show();
        $(input).removeClass("valid").addClass("invalid");
    }

    inputSubmit(input) {
        if (input.hasClass('valid')) {
        } else {
            return false;
        }
    }

    inputBlur() {
        $('.error-message').empty();
        return true;
    }

    emailIsValid(e, input) {
        var email = input[0].value;
        if (email || this.model.get("msisdn")) {
            var message = $(e).next("span");
            message.empty();
            message.hide();
            $(input).removeClass("invalid").addClass("valid");
            $(e).find("button[type=submit]").removeAttr("disabled");
        } else {
            this.emailIsInvalid(e, input);
        }
    }

    emailIsInvalid(e, input) {
        var email = input[0].value;
        if (!email && this.model.get("msisdn")) {
            this.emailIsValid(e, input);
        } else {
            var message = $(e).next("span");
            message.text(i18n.t("passwordrecover.notvalidmail"));
            message.show();
            $(input).removeClass("valid").addClass("invalid");
            $(e).find("button[type=submit]").attr("disabled", "disabled");
        }
    }

    emailSubmit(input) {
        if (input.hasClass('valid')) {
        } else {
            return false;
        }
    }

    customFieldIsValid(e, input) {
        $(input).removeClass("invalid").addClass("valid");
        var message = $(e).next("span");
        message.empty();
        message.hide();
    }


    customFieldIsInvalid(e, input) {
        var type = $(e).data("custom-field-type");
        var message = $(e).next("span");
        if (type === 'decimal') {
            message.text(i18n.t("customFieldDecimalTypeError"));
        } else if (type === 'varchar') {
            message.text(i18n.t("customFieldVarcharTypeError"));
        }
        message.show();
        $(input).removeClass("valid").addClass("invalid");
    }

    customFieldSubmit(input) {
        var type = $(input[0]).parent().parent().data("custom-field-type");

        if(type !== 'datetime' && !input.hasClass('valid'))
            return false; // return something ONLY in case it is invalid
    }

    customFieldBlur() {
        $('.error-message').empty();
        return true;
    }

    loadSubscriberRating(id) {
        $.ajaxDefaultQ({
            url: `/CampaignCloud/Report/${id}/getSubscriberSatisfactionAndEngagement`,
            dataType: "json"
        }).done(function (response) {
            if (!response)
                return;
            const [satScore, engScore] = response;

            function printableScore(score) {
                const scoreDecimal = (score || 0) * 10;
                return scoreDecimal > 0 ? (scoreDecimal) % 1 === 0 ? scoreDecimal : (scoreDecimal).toFixed(2) : '-';
            }

            const engagement = printableScore(engScore);
            const satisfaction = printableScore(satScore);
            $("#subscriberSatisfaction").find(".metricValue ").html(satisfaction);
            $("#subscriberEngagement").find(".metricValue ").html(engagement);
        }).fail(function (re) {
            console.info("An error occurred!");
            console.info(re);
        });
        if (this.subscriberCode === null){
            $('#addPoints').hide();
        }

    }

    @handles("toggleBlock")
    @handles("toggleBounced")
    async updateSubscriberGroups() {
        const updatedData = await $.ajaxDefaultQ({
            url: `${this.model.url()}/Groups`,
            type: 'GET',
            dataType: 'json'
        });

        this.groupTilesView = new TilesView({
            collection: updatedData.data, contactModel: this.model,
            groupsCount: this.$(".groups-count")
        });

        this.groupTilesView.renderCollection();

        const blocked = updatedData.data.filter(obj => obj.id === 1).length > 0;

        if (blocked) {
            const additionalInfo = await $.ajaxDefaultQ({
                url: `${this.model.url()}/AdditionalInfo`,
                type: 'GET',
                dataType: 'json'
            });
            this.blockedDate = additionalInfo.blockDate;
            this.model.set("blockedDate", this.blockedDate);
            this.$("#blocked-date").html(Handlebars.compile(`{{t "subscriber.blockedsince"}} {{timestamp ${this.blockedDate} "LTS L"}}, {{reltimestamp ${this.blockedDate} }}`));

        }
        this.toggleBlockedState(blocked);

        const bouncedEmail = updatedData.data.filter(group => group.title === 'BOUNCED EMAILS').length > 0;

        if (bouncedEmail) {
            const bouncedEmailDate = await $.ajaxDefaultQ({
                url: `${this.model.url()}/getEmailBouncedDate`,
                type: 'get',
                dataType: 'json'
            });
            this.bouncedEmailDate = bouncedEmailDate.bouncedEmailDate;
            this.model.set("bouncedEmailDate", this.bouncedEmailDate);
            this.$("#bounced-email-date").html(Handlebars.compile(`{{t "subscriber.emailBouncedSince"}} {{timestamp ${this.bouncedEmailDate} "LTS L"}}, {{reltimestamp ${this.bouncedEmailDate} }}`));

        }
        this.toggleEmailState(bouncedEmail);

        const bouncedMsisdn = updatedData.data.filter(group => group.title === 'BOUNCED SMS').length > 0;

        if (bouncedMsisdn) {
            const bouncedSmsDate = await $.ajaxDefaultQ({
                url: `${this.model.url()}/getSmsBouncedDate`,
                type: 'get',
                dataType: 'json'
            });
            this.bouncedSmsDate = bouncedSmsDate.bouncedSmsDate;
            this.model.set("bouncedSmsDate", this.bouncedSmsDate);
            this.$("#bounced-sms-date").html(Handlebars.compile(`{{t "subscriber.smsBouncedSince"}} {{timestamp ${this.bouncedSmsDate} "LTS L"}}, {{reltimestamp ${this.bouncedSmsDate} }}`));

        }
        this.toggleMsisdnState(bouncedMsisdn);

    }

    @on('click #subscriberPhotoBox')
    togglePhotoOptions() {
        $("#photoConf").slideToggle();
    }

    @on('click #addPoints')
    addPointsForSubscriber() {
        if (this.subscriberCode) document.location.href = "RedeemVoucher.htm#" + this.subscriberCode;
        else document.location.href = "RedeemVoucher.htm";
    }

    @on('click #uploadPhoto')
    uploadPhoto(e) {
        e.stopPropagation();
        const addHandler = function (e, data) {
            const maxFileSize = 1024 * 1024 * 5; //1Mb
            const file = data.files[0];
            const {name, type, size} = file;

            var prettifiedFileSize = Handlebars.helpers.formatBytesSize(size, "si");
            var prettifiedMaxFileSize = "5MB"; //"1MB";
            if (size > maxFileSize) {
                dhtmlx.alert({
                    text: i18n.t("fileup.invalidFileSize", {
                        fileSize: prettifiedFileSize,
                        maxFileSize: prettifiedMaxFileSize
                    })
                });
                return;
            }
            if (!/^image\/.+$/.test(type)) { //checking for file type, need to be an image
                dhtmlx.alert({
                    text: i18n.t("fileup.notsupportedfile", {filename: type})
                });
                return;
            }

            var fr = new FileReader;

            fr.onload = function () {
                var img = new Image;

                img.onload = function () {
                    var max = 1000;
                    var width = img.width;
                    var height = img.height;
                    var aspectRatio = width / height;

                    if (width <= max && height <= max && (aspectRatio >= 0.5 && aspectRatio <= 2)) {
                        dhtmlx.confirm({
                            ok: i18n.t("message.yes"),
                            cancel: i18n.t("message.no"),
                            text: i18n.t("subscriber.confirmupload", {file: name}),
                            callback: function (result) {
                                if (result) {
                                    data.formData = {file: file};
                                    data.submit();
                                }
                            }
                        });
                    } else {
                        dhtmlx.alert({
                            text: i18n.t("fileup.notsupportedfiledimensions", {filename: type})
                        });
                    }
                };

                img.src = fr.result;
            };

            fr.readAsDataURL(data.files[0]);
        };
        $("#photoToUpload").trigger("click")
            .fileupload({
                dataType: 'json',
                url: '/CampaignCloud/Subscription/' + $("#uploadPhoto").attr("data-id") + '/photo/add',
                autoUpload: false,
                singleFileUploads: true,
                limitMultiFileUploads: 1,
                maxNumberOfFiles: 1,
                //maxFileSize: ,
                submit: function (e, data) {
                },
                send: function (e, data) {
                    //console.info("send event");
                },
                add: addHandler,
                change: function (e, data) {
                    data.eventOccurred = "change";
                },
                done: function () {
                    dhtmlx.alert({
                        text: i18n.t("subscriber.photouplaodedsuccessfully"),
                        callback: function () {
                            location.reload();
                        }
                    });
                },
                fail: function () {
                    $.Notify.error("Error");
                }
            });
    }

    @on('click #removePhoto')
    removePhoto(e) {
        e.stopPropagation();
        var subscriptionId = $(e.currentTarget).attr("data-id");
        dhtmlx.confirm({
            ok: i18n.t("message.yes"),
            cancel: i18n.t("message.no"),
            text: i18n.t("subscriber.removephototext"),
            callback: function (result) {
                if (result) {
                    $.ajaxDefaultQ({
                        url: `/CampaignCloud/Subscription/${subscriptionId}/photo/remove`,
                        type: 'DELETE'
                    }).done(function (resp) {
                        if (resp.outcome === "OK") {
                            dhtmlx.alert({
                                text: i18n.t("subscriber.photoremoved"),
                                callback: function () {
                                    location.reload();
                                }
                            });
                        } else if (resp.outcome === "NO_PHOTO_EXISTS") {
                            $.Notify.error(i18n.t("subscriber.nophotoexists"));
                        }
                    }).fail(function (resp) {
                        console.error("Error: " + resp);
                    });
                }
                $("#photoConf").slideUp();
            }
        });
    }

    validateBirthDate(input) {
        var inputDate = new Date(input.val());
        if (new Date().getFullYear() < inputDate.getFullYear()) {
            $.Notify.error(i18n.t("subscriber.birthdayNotAfterNow"));
            return false;
        }
    }

    @on('change .customFieldsChange')
    async showHideMultipleChoiceOptions(e) {
        const $select = $(e.currentTarget);
        const cf_id = $select.attr("id").replace(/[^0-9.]+/g, "");
        const newValueOfMultipleChoice = $select.val();

        this.model.saveAttribute(`custom_field_${cf_id}`, newValueOfMultipleChoice, (attr, value, outcome) => {
            if (outcome === "OK") {
                this.model.set(`custom_field_${cf_id}`, newValueOfMultipleChoice);
                $.Notify.show(i18n.t("generic.attributechangedto", {
                    attributeName: attr,
                    value: value,
                    outcome: i18n.t(`generic.=${outcome}`)
                }));
            } else {
                $.Notify.error(i18n.t("generic.attributechangedto", {
                    attributeName: attr,
                    value: value,
                    outcome: i18n.t(`generic.=${outcome}`)
                }));
            }
        });
    }


}

export default SubscriberView;
